import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/subscription/subscription.component')
      .then(m => m.SubscriptionComponent)
  },
  {
    path: 'subscription',
    loadComponent: () => import('./features/subscription/subscription.component')
      .then(m => m.SubscriptionComponent)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
